import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import moment from 'moment'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import * as toastr from 'toastr'
import History from '../forms/history.vue'

if ($('#overproduction').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#overproduction',
    components: {
      datePicker,
      RingLoader,
      History
    },
    mixins: [mixins],
    data: {
      date: moment().locale('pl').format('YYYY-MM-DD'),
      loading: 0,
      items: [],
      generated: false,
    },
    watch: {
      date: function () {
        this.generate()
      }
    },
    methods: {
      async generate() {
        this.loading++
        this.generated = false
        this.items = await this.getOverproduction()
        this.generated = true
        this.loading--
      },
      reset() {
        this.items = this.items.map((el) => {
          el.actualDifference = 0
          return el
        })
      },
      getOverproduction() {
        $('.button-generate').button('loading')
        let url = Routing.generate('api_overproduction_production_list', { date: this.date })

        return this.$http.get(url).then(response => {
          $('.button-generate').button('reset')
          return response.data
        })
      },
      async saveOverproduction() {
        $('.button-save').button('loading')
        let url = Routing.generate('api_post_production_list_save_overproduction_and_generate_production_list', { date: this.date })

        this.$http.post(url, this.items ).then(() => {
          toastr.success(Translator.trans('overproduction.save_success'))
          this.generate()
          $('.button-save').button('reset')
        }, response => {
          toastr.error(Translator.trans(response.data.message))
          this.generate()
          $('.button-save').button('reset')
        })
      },
      prepareHistoryUrl() {
        return Routing.generate('api_get_entity_logger_show_overproduction', { date: this.date })
      },
    },
  })
}
